module.exports = __webpack_public_path__ + "media/assets/images/landings/contact_center/contact_center_logo_big-d737811f068a1ff93f8f0c81b481cfd6.svg";